import React, { Component } from "react"
import { Button, Icon } from "semantic-ui-react"

//component
import ButtonSigninMaterial from "./ButtonSigninMaterial"

//material ui
import TextField from "@material-ui/core/TextField"
import Avatar from "@material-ui/core/Avatar"
import FormControl from "@material-ui/core/FormControl"
import LockOutlinedIcon from "@material-ui/icons/LockOutlined"
import Typography from "@material-ui/core/Typography"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import CircularProgress from "@material-ui/core/CircularProgress"

class LoginForm extends Component {
	render() {
		const {
			t,
			classes,
			handleClickClose,
			Open,
			handleClickOpen,
			finishlocal,
			erroremail,
			email,
			password,
			handleChange,
			validateForm,
			handleConfirmationSubmit,
			finishgm,
			finishfb,
			finishln,
			handleClickGM,
			handleClickFB,
			handleClickLN,
			login_gm,
			login_fb,
			login_ln,
			create_user,
			get_user,
			update_latest_login,
			history
		} = this.props
		return (
			<Dialog
				open={Open}
				onClose={handleClickClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				className="Logindialog"
			>
				<DialogContent className={classes.paper}>
					<Avatar className={classes.avatar}>
						<LockOutlinedIcon />
					</Avatar>
					<Typography
						variant="h5"
						component="h3"
						style={{ fontSize: 18, fontFamily: "Roboto, sans-serif" }}
					>
						{t("NavBarDesktop.NavBarDesktopSignIn")}
					</Typography>
					<div className={classes.form}>
						<div className={classes.root}>
							<div className={classes.wrapper}>
								<Button
									aria-label="handleClickGM"
									disabled={finishgm}
									className="buttonsignin"
									color="google plus"
									onClick={(event) =>
										handleClickGM({
											event,
											t,
											login_gm,
											handleClickClose,
											create_user,
											get_user,
											update_latest_login,
											history
										})
									}
								>
									<Icon name="google" /> Login with Google
								</Button>
								{finishgm && (
									<CircularProgress
										size={24}
										className={classes.buttonProgress}
									/>
								)}
							</div>
						</div>
						<div className={classes.root}>
							<div className={classes.wrapper}>
								<Button
									aria-label="handleClickFB"
									disabled={finishfb}
									className="buttonsignin"
									color="facebook"
									onClick={(event) =>
										handleClickFB({
											event,
											t,
											login_fb,
											handleClickClose,
											create_user,
											get_user,
											update_latest_login,
											history
										})
									}
								>
									<Icon name="facebook" /> Login with Facebook
								</Button>
								{finishfb && (
									<CircularProgress
										size={24}
										className={classes.buttonProgress}
									/>
								)}
							</div>
						</div>
						<div className={classes.root}>
							<div className={classes.wrapper}>
								<Button
									aria-label="handleClickLN"
									disabled={finishln}
									className="buttonsignin"
									color="linkedin"
									onClick={(event) =>
										handleClickLN({
											event,
											t,
											login_ln,
											handleClickClose,
											create_user,
											get_user,
											update_latest_login,
											history
										})
									}
								>
									<Icon name="linkedin" /> Login with LinkedIn
								</Button>
								{finishln && (
									<CircularProgress
										size={24}
										className={classes.buttonProgress}
									/>
								)}
							</div>
						</div>

						<div style={{ textAlign: "center" }} className="text-divider">
							<span>OR</span>
						</div>
					</div>
					<form className={classes.form}>
						<FormControl style={{ marginBottom: 8 }} required fullWidth>
							<TextField
								error={erroremail}
								id="email"
								label={t("login.loginEmail")}
								placeholder={t("login.eg")}
								value={email}
								onChange={handleChange}
								autoFocus
							/>
						</FormControl>
						<FormControl required fullWidth>
							<TextField
								type="password"
								id="password"
								label={t("login.loginPassword")}
								placeholder={t("login.loginEnterPassword")}
								value={password}
								onChange={handleChange}
							/>
						</FormControl>
						<Typography
							className={classes.typographytitle1}
							onClick={handleClickClose}
						>
							<span
								className="link_a"
								onClick={(e) => handleClickOpen(e, "ForgotPassword")}
							>
								{t("login.loginForgotPassword")}
							</span>{" "}
							|{" "}
							<span
								className="link_a"
								onClick={(e) => handleClickOpen(e, "ConfirmRegistration")}
							>
								{t("login.loginConfirmRegistration")}
							</span>
						</Typography>
						<ButtonSigninMaterial
							t={t}
							classes={classes}
							finishlocal={finishlocal}
							handleConfirmationSubmit={handleConfirmationSubmit}
							validateForm={validateForm}
						/>
						<Typography
							className={classes.typographytitle}
							onClick={handleClickClose}
						>
							{t("login.loginneedanaccount")}
							&nbsp;
							<span
								className="link_a"
								onClick={(e) => handleClickOpen(e, "Sign up")}
							>
								{t("NavBarDesktop.NavBarDesktopSignUp")}
							</span>
						</Typography>
					</form>
				</DialogContent>
			</Dialog>
		)
	}
}
export default LoginForm
